import React from 'react';
import styled from 'styled-components';

import {
  Header as HeaderLayoutComponent, Loader as LoaderLayoutComponent, Text as TextLayoutComponent, Segment as SegmentLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Text = styled(TextLayoutComponent)``;

export const Header = styled(HeaderLayoutComponent)``;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  margin: 80px auto 0px auto;
  max-width: 1200px;
`;

export const Centered = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  margin: 50px 0px;
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    width: 650px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px ${({ isPadding }) => (isPadding ? '100px' : '')};
  }
`;

export const Loader = styled(LoaderLayoutComponent)`
  align-self: center !important;
  display: flex !important;
  margin-top: 150px !important;
  margin: auto !important;
  margin-bottom: 20px;
`;

export const ContainerLoader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const Instructions = styled.div`
  display: inline-flex;
`;

export const Bold = styled.strong`
  font-weight: 500;
`;

export const Title = styled(TextLayoutComponent.Title)`
  font-size: 20px;
  margin-bottom: 25px;
  text-align: center;
`;

const EmptyContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const Empty = () => (
  <EmptyContainer>
    <Title>We couldn&apos;t find any studies that matched your profile.</Title>
  </EmptyContainer>
);

export const Loading = () => (
  <ContainerLoader>
    <Loader data-loader="browse-test-studies-loader" />
    <Title>One moment! We’re loading studies that match your profile</Title>
  </ContainerLoader>
);
